export function buildFrameworkEntityAliasesFromStructure(structure) {
    if (!structure) {
        return null;
    }
    const aliasesByEntityType = Object.fromEntries((structure.entityDisplays ?? [])
        .filter((display) => typeof display?.entityTypeKey === "string" &&
        display.entityTypeKey.length > 0 &&
        typeof display.alias === "string" &&
        display.alias.length > 0)
        .map((display) => [display.entityTypeKey, display.alias]));
    return { aliasesByEntityType };
}
export function tryGetEntityAliasFromStructure(structure, entityTypeKey) {
    return tryGetEntityAlias(buildFrameworkEntityAliasesFromStructure(structure), entityTypeKey);
}
export function tryGetEntityAlias(aliases, entityTypeKey) {
    if (!aliases) {
        return null;
    }
    return aliases.aliasesByEntityType[entityTypeKey] ?? null;
}
export function createMissingEntityAliasError(entityTypeKey) {
    return new Error(`Missing framework entity alias for '${entityTypeKey}'. ` +
        "frameworkStructure.entityDisplays[].alias is required.");
}
export function getRequiredEntityAlias(aliases, entityTypeKey) {
    const alias = tryGetEntityAlias(aliases, entityTypeKey);
    if (alias) {
        return alias;
    }
    throw createMissingEntityAliasError(entityTypeKey);
}
